module.exports = __webpack_public_path__ + "img/site-web-refonte-5.441b04a.jpg";